
/**
 * Internal dependencies
 */
import {
    RENTAL_PLANS_RECEIVE,
    RENTAL_PLANS_REQUEST,
    RENTAL_PLANS_REQUEST_SUCCESS,
    RENTAL_PLANS_REQUEST_FAILURE,
} from 'state/action-types';

import cscom from 'lib/customer-site-api';
import { 
    getAllRentalPlans, 
    requestingRentalPlans, 
    getAllRetailerRentalPlans, 
    requestingRetailerRentalPlans 
} from './selectors';

/**
 * [description]
 * 
 * @param  {Function} includeSupport [description]
 * @return {[type]}                  [description]
 */
export const requestRentalPlans = () => (dispatch) => {
    dispatch({ type: RENTAL_PLANS_REQUEST });
    return cscom
        .retailerRentalPlan()
        .list()
        .then(rentalPlans => {
            dispatch({ type: RENTAL_PLANS_REQUEST_SUCCESS });
            dispatch({ type: RENTAL_PLANS_RECEIVE, payload: { items: rentalPlans } });
            return rentalPlans;
        })
        .catch((error) => {
            dispatch({ type: RENTAL_PLANS_REQUEST_FAILURE, error });
        });
}

export const requestRetailerRentalPlans = () => (dispatch) => {
    dispatch({ type: RENTAL_PLANS_REQUEST });
    return cscom
        .retailerRentalPlan()
        .list()
        .then(retailerRentalPlans => {
            dispatch({ type: RENTAL_PLANS_REQUEST_SUCCESS });
            dispatch({ type: RENTAL_PLANS_RECEIVE, payload: { items: retailerRentalPlans } });
            return retailerRentalPlans;
        })
        .catch((error) => {
            dispatch({ type: RENTAL_PLANS_REQUEST_FAILURE, error });
        });
}

/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestPlansIfNotRequested = (...props) => async (dispatch, getState) => {
	
	const plans = getAllRentalPlans(getState());
	const requesting = requestingRentalPlans(getState());

	if (plans.length == 0 && requesting == false) {
		return dispatch(requestRentalPlans(...props))
	}

	return plans;
}

/**
 * [description]
 * 
 * @param  {...[type]} props) [description]
 * @return {[type]}           [description]
 */
export const requestRetailerPlansIfNotRequested = (...props) => async (dispatch, getState) => {
    
    const plans = getAllRetailerRentalPlans(getState());
    const requesting = requestingRetailerRentalPlans(getState());

    if (plans.length == 0 && requesting == false) {
        return dispatch(requestRetailerRentalPlans(...props))
    }

    return plans;
}